import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ddt from '@wix/da-ddt';
import { useAvailableSpace } from '@wix/da-hooks/pkg/useAvailableSpace';
import { MeasuredCookieType, } from '../../Measured';
import { updateMeasuredCookie } from '../../Measured/redux/actions';
import { makeGetPrevLoadDims } from '../../Measured/redux/selectors';
var logger = ddt.createLogger('artstage');
export function useMeasuredStage(ref, shouldUpdateCookie, cookieType, cookieDim) {
    if (shouldUpdateCookie === void 0) { shouldUpdateCookie = true; }
    if (cookieType === void 0) { cookieType = MeasuredCookieType.DEVIATION_ARTSTAGE; }
    if (cookieDim === void 0) { cookieDim = 'both'; }
    var dispatch = useDispatch();
    var getPrevLoadDims = useMemo(function () { return makeGetPrevLoadDims(); }, []);
    var prevLoadDims = useSelector(function (state) {
        return getPrevLoadDims(state, cookieType, cookieDim);
    });
    logger.log('Cookie dims', prevLoadDims);
    var onResize = useCallback(function (_a) {
        var contentSize = _a.contentSize;
        if (contentSize && shouldUpdateCookie) {
            logger.log('Updating cookie', contentSize);
            dispatch(updateMeasuredCookie(cookieType, cookieDim, contentSize)); // only the contentSize is important to save
        }
    }, [cookieDim, cookieType, dispatch, shouldUpdateCookie]);
    var sizes = useAvailableSpace(ref, onResize, {
        contentSize: {
            width: prevLoadDims.width || undefined,
            height: prevLoadDims.height || undefined,
        },
    });
    return sizes;
}
//# sourceMappingURL=useMeasuredStage.js.map